import { render, staticRenderFns } from "./db.vue?vue&type=template&id=38a6c486&scoped=true&"
import script from "./db.vue?vue&type=script&lang=js&"
export * from "./db.vue?vue&type=script&lang=js&"
import style0 from "./db.vue?vue&type=style&index=0&id=38a6c486&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a6c486",
  null
  
)

export default component.exports